import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import {
  grammarItemResponseSchema,
  grammarPointSummarySchema,
  grammarUserStateSchema,
} from '../schemas';

const grammarWorkoutEntrySchema = z.object({
  point: grammarPointSummarySchema,
  state: grammarUserStateSchema,
  item: grammarItemResponseSchema,
});

const getGrammarWorkoutV1DataSchemaDefinition = z.object({
  items: z.array(grammarWorkoutEntrySchema),
});

export const getGrammarWorkoutV1DataSchema: typeof getGrammarWorkoutV1DataSchemaDefinition =
  getGrammarWorkoutV1DataSchemaDefinition;

export type IGetGrammarWorkoutV1Data = z.infer<typeof getGrammarWorkoutV1DataSchema>;

export const getGrammarWorkoutV1ResponseSchema: z.ZodSchema<IAPI<IGetGrammarWorkoutV1Data>> =
  createApiResponseSchema(getGrammarWorkoutV1DataSchema) as z.ZodSchema<
    IAPI<IGetGrammarWorkoutV1Data>
  >;

export type IGetGrammarWorkoutV1Response = IAPI<IGetGrammarWorkoutV1Data>;
